var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('app-tab',{attrs:{"tabs":_vm.tabs,"icon":_vm.pageIcon,"isShowHeader":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }